import React from "react";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  text: string;
  onClick?: () => void; // Optional onClick prop
}

const WebBackButton: React.FC<BackButtonProps> = ({ text, onClick }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={onClick ? onClick : () => navigate(-1)} // Use custom handler or default to navigate(-1)
      className="text-gray-500 text-sm mb-6 flex items-center"
    >
      <span className="mr-2">←</span> {text}
    </button>
  );
};

export default WebBackButton;
